var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.92 16.963C33.92 20.8186 30.7904 23.9432 26.9314 23.9432C23.0767 23.9432 19.9521 20.8177 19.9521 16.963C19.9521 13.1083 23.0767 9.98288 26.9314 9.98288C30.7904 9.98288 33.92 13.1083 33.92 16.963Z",
    fill: "#73C7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9425 0C23.7122 0 19.2 1.28773 15.9316 4.55613L19.8134 11.6285C20.6617 10.549 21.7443 9.67654 22.9793 9.07704C24.2144 8.47754 25.5696 8.1667 26.9425 8.16803C29.8691 8.16803 32.4733 9.55052 34.1325 11.7004L37.9398 4.39368C35.1114 1.30296 30.0391 0 26.9425 0ZM29.8192 5.19322H28.0119V6.99875H25.8409V5.19322H24.0337V3.02304H25.8409V1.20989H28.0119V3.02304H29.8192V5.19322Z",
    fill: "#73C7A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7585 36.4888H19.5463L16.9928 45.2406H36.9442L34.4026 36.4888H36.192L38.7497 45.2406H44.6207L40.6136 31.9809C39.9875 29.7921 37.2429 25.9382 32.5065 25.8214L21.6175 25.8121C16.7737 25.8358 13.9715 29.765 13.3378 31.98L9.25293 45.2398H15.2068L17.7585 36.4888Z",
    fill: "#73C7A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.821289 48.031H53.0497V53H0.821289V48.031Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewOne);
export default __webpack_public_path__ + "static/media/newOne.dfac9755f3e5dbdd044ed363e758b2e8.svg";
export { ForwardRef as ReactComponent };